import { OwnTransportIngredient } from '@apps/main/modules/recipe/ingredients';

import {
  GraphQL,
  IngredientType,
  TransportType,
} from '@libs/trip-planner-interfaces';
import type {
  ExposedOwnTransportIngredient,
  OwnTransportType,
} from '@libs/trip-planner-interfaces';

export function createExposedOwnTransportIngredient(
  ownTransportIngredient: OwnTransportIngredient
): ExposedOwnTransportIngredient {
  const ownTransportType = getOwnTransportTypeQL(
    ownTransportIngredient.ownTransportType
  );

  return {
    ingredientType: IngredientType.OwnTransport,
    ownTransportType,
  };
}

export function createOwnTransportIngredient(
  exposedOwnTransportIngredient: ExposedOwnTransportIngredient
): OwnTransportIngredient {
  let ownTransportType: OwnTransportType = TransportType.None;
  if (exposedOwnTransportIngredient.ownTransportType) {
    ownTransportType = getOwnTransportType(
      exposedOwnTransportIngredient.ownTransportType
    );
  }
  const ownTransportIngredient = new OwnTransportIngredient(ownTransportType);

  return ownTransportIngredient;
}

function getOwnTransportTypeQL(
  ownTransportType: OwnTransportType
): GraphQL.OwnTransportTypeQL {
  switch (ownTransportType) {
    case TransportType.Car:
      return GraphQL.OwnTransportTypeQL.Car;
    case TransportType.Bicycle:
      return GraphQL.OwnTransportTypeQL.Cycle;
    case TransportType.Walk:
      return GraphQL.OwnTransportTypeQL.Walk;
    case TransportType.None:
      return GraphQL.OwnTransportTypeQL.Unknown;
    default:
      throw new Error('Unknown transport type');
  }
}

function getOwnTransportType(
  ownTransportTypeQL: GraphQL.OwnTransportTypeQL
): OwnTransportType {
  switch (ownTransportTypeQL) {
    case GraphQL.OwnTransportTypeQL.Car:
      return TransportType.Car;
    case GraphQL.OwnTransportTypeQL.Cycle:
      return TransportType.Bicycle;
    case GraphQL.OwnTransportTypeQL.Walk:
      return TransportType.Walk;
    case GraphQL.OwnTransportTypeQL.Unknown:
      return TransportType.None;
    default:
      throw new Error('Unknown own transport type');
  }
}
